import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { AIChatSidebar } from "@/components/ai/AIChatSidebar";
import { FloatingSalesWizard } from "@/components/wizard/FloatingSalesWizard";
import { useIsMobile } from "@/hooks/use-mobile";
import { useGuidanceGraduation } from "@/hooks/useGuidanceGraduation";
import { cn } from "@/lib/utils";

export function AppLayout() {
  const isMobile = useIsMobile();
  
  // Check and graduate user based on activity
  useGuidanceGraduation();

  return (
    <div className="h-screen overflow-hidden bg-background">
      {!isMobile && <Sidebar />}
      <div className={cn(
        "h-screen flex flex-col transition-all duration-300",
        isMobile ? "pl-0" : "pl-64"
      )}>
        <Header />
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
      <AIChatSidebar />
      {!isMobile && <FloatingSalesWizard />}
    </div>
  );
}
